<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-main ref="main">
        <div class="header">
          <div class="left">
            <div class="left-top">
              <div class="Bj-color"></div>
              <div style="height: 15%">
                <span class="title">新品总览 (个)</span>
                <span class="title-Company">(近3个月)</span>
              </div>
              <div class="spu-box" v-if="newProductOverviewData.num.length">
                <div v-for="(item,index) in newProductOverviewData.num" :key="index">
                  <div class="spu-num" @click="newProduct(index)">{{newProductOverviewData.num[index]}}</div>
                  <div class="spu-type">{{newProductOverviewData.name[index]}}</div>
                  <div>
                    <img
                      :src="require('../../../assets/images/lifeCycle_img/'+ newProductOverviewData.img[index] + '@2x.png')"
                      class="spu-img"
                    />
                    <!-- :class="`${windowWith == 1920 ? '' : 'spu-img'}`" -->
                  </div>
                </div>
              </div>
            </div>
            <div class="left-bottom">
              <div class="Bj-color"></div>
              <div style="height: 10%">
                <span class="title">产品数量分布</span>
              </div>
              <div class="product">
                <div class="product-tilteBox">
                  <div>
                    <span class="product-titleText">产品</span>
                    <span class="product-Company"> (个)</span>
                  </div>
                  <div>
                    <span class="product-titleText">总数</span>
                    <span class="product-num" @click="productLink"> {{this.ProductTypeList[0] ? this.ProductTypeList[0].proTotalCount : '' }}</span>
                  </div>
                </div>
                <div class="product-type">
                  <div
                    class="product-border-box"
                    v-for="item in ProductTypeList"
                    :key="item.groupRule"
                    @click="productDetailsLink(item.groupRule)"
                  >
                    <div class="product-type-header">{{item.proCount}}</div>
                    <div class="product-type-content">{{item.groupRule}}</div>
                    <div>
                      <div class="rise">环比增长</div>
                      <div :class="`${item.proportionChangeFlag == 'up' ? 'uptext' : 'downtext'} rise`">{{item.proportion}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="largeModel">
                <div
                  class="largeModel-boderBox"
                  v-for="item in modelTypeList"
                  :key="item.groupRule"
                  @click="largeModelLink(item.groupRule)"
                >
                  <div class="largeModel-title">
                    <span class="largeModel-titleText">{{item.groupRule}}</span>
                    <span class="largeModel-Company"> (个)</span>
                  </div>
                  <div class="largeModel-content">
                    <div>{{item.proCount}}</div>
                    <div :class="`${item.proportionChangeFlag == 'up' ? 'uptext' : 'downtext'} rise`">同比{{item.proportionChangeFlag == 'up'? '增长' : '下降'}}{{item.proportion}}</div>
                  </div>
                </div>
                <div class="largeModel-dow" @click="productDetailsLink(unsalable.groupRule)">
                  <div class="largeModel-dow-title">
                    <span class="largeModel-titleText">{{unsalable.groupRule}}</span>
                    <span class="largeModel-Company"> (个)</span>
                  </div>
                  <div class="largeModel-dow-content" v-if="unsalable.proportionChangeFlag">
                    <div>{{unsalable.proCount}}</div>
                    <div :class="`${unsalable.proportionChangeFlag == 'up' ? 'uptext' : 'downtext'} rise`">同比{{unsalable.proportionChangeFlag == 'up'? '增长' : '下降'}}{{unsalable.proportion}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="Bj-color"></div>
            <div class="right-top">
              <div
                style="width: calc(30% - 0.52vw); height: calc(100% + 0.52vw)"
                class="right-borderBox"
              >
                <div style="height: 15%">
                  <span class="title">品类销量TOP5</span>
                  <span class="title-Company">({{this.categorySaleTopList[0] ? this.categorySaleTopList[0].categoryCount : ''}}个品类)</span>
                </div>
                <div class="category-Top">
                  <div
                    class="category"
                    v-for="item in categorySaleTopList"
                    :key="item.rankingNum"
                    @click="categoryTop(item.categoryName)"
                  >
                    <div>{{ item.rankingNum }}</div>
                    <span class="categoryName">{{ item.categoryName }}</span>
                  </div>
                </div>
              </div>
              <div style="width: 70%; height: 100%; position: relative">
                <div class="cavans-title">各月销量走势</div>
                <div class="salesVolume-box">
                  <span class="salesVolume-text">总销售量</span>
                  <span class="salesVolume-num">{{salesVolume}}</span>
                </div>
                <div class="right-borderBox">
                  <div ref="line" class="cavans"></div>
                </div>
              </div>
            </div>
            <div class="right-bottom">
              <div style="width: 30%; height: 100%; position: relative">
                <div class="cavans-title">销量同比去年</div>
                <div :class="`right-borderBox ${modelTypeList.length ? 'pieColor' : ''} `" @click="pieClick()">
                  <div ref="pie1" class="cavans"></div>
                </div>
              </div>
              <div style="width: 30%; height: 100%; position: relative" v-if="columnJurisdiction">
                <div class="cavans-title">销售额同比去年</div>
                <div :class="`right-borderBox ${modelTypeList.length ? 'pieColor' : ''} `" @click="pieClick()">
                  <div ref="pie2" class="cavans"></div>
                </div>
              </div>
              <div :style="`width: ${columnJurisdiction ? '40%' : '70%'}; height: 100%; position: relative`">
                <div class="cavans-title">新品月均销量分布 <span class="title-Company"> (产品数)</span></div>
                <div class="right-borderBox">
                  <div ref="bar" class="cavans"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="Bj-color"></div>
          <div style="height:15% ;padding-bottom:10px">
            <span class="title">全网清仓情况</span>
            <!-- <span class="salesVolume-num">(敬请期待)</span> -->
          </div>
          <el-table
            class="exporttable"
            ref="table"
            height="calc(85% - 5px)"
            border
            :data="tableData"
            :header-cell-style="{ borderColor: '#53AD9F' }"
            :cell-style="{borderColor: '#34786C',}"
            style="width: 100%"
          >
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed"
            :min-width="item.width"
            show-overflow-tooltip
            v-for="item in columnData"
            :key="item.prop"
            :align="item.children ? 'center' : 'left'"
          >
            <template slot-scope="scope">
              {{ scope.row[item.prop] }}
            </template>
          </el-table-column>
        </el-table>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import moment from "moment";
import lineMixin from "./line.mixin";
import pie1Mixin from "./pie1.mixin";
import pie2Mixin from "./pie2.mixin";
import barMixin from "./bar.mixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'Administration',
  mixins: [lineMixin, pie1Mixin, pie2Mixin, barMixin, pagePathMixin],
  computed: {
    windowWith() {
      return document.documentElement.clientWidth;
    },
    menus() {
      return this.$store.state.menu.menus
    }
  },
  data() {
    return {
      tableHeight: 0,
      loading: false,
      formData: {
        category: "",
        tag: "",
      },
      tableData: [],
      addDescVisible: false,
      addCategoryVisible: false,
      ProductTypeList: [],
      modelTypeList: [],
      unsalable: {},
      categorySaleTopList: [],
      newProductOverviewData: {
        num: [],
        name: [],
        img: []
      },
      columnJurisdiction: false,
      salesVolume: '',
      columnData: [],
    };
  },
  mounted() {
    this.buttonJurisdiction()
    this.init();
  },
  methods: {
    buttonJurisdiction() {
      this.$q.user.authListUserButton({params: { subAppCode: 'ec-pc-new' }}) .then(({ data })=>{
        // 将权限列表写入local
        let Jurisdiction = "ec-pc-new$analysisDashboard$lifeCycleAnalysis$Administration$salesVolume";
        this.columnJurisdiction = data.includes(Jurisdiction);
      })
    },
    init() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const request1 = this.$q.productLifeCycle.newProductOverview({});
      const request2 = this.$q.productLifeCycle.soldProducts({  });
      const request3 = this.$q.productLifeCycle.distributed({});
      const request4 = this.$q.productLifeCycle.categorySaleTop();
      const request5 = this.$q.productLifeCycle.saleMsgProportion();
      const request6 = this.$q.productLifeCycle.monthSaleChart({
        data: { type: "1"},
      });
      const request7 = this.$q.productLifeCycle.completeInfoSearch({data: {pageSize:3,pageNum:1} })
      Promise.all([
        request1,
        request2,
        request3,
        request4,
        request5,
        request6,
        request7
      ])
        .then((res) => {
          this.newProductOverviewData = {
            num:[
               res[0].data.onShelfNum,
               res[0].data.notOnShelfNum,
               res[0].data.notOnShelfTimeoutNum,
            ],
            name: [
              '已上架SPU','未上架SPU','未上架超时SPU'
            ],
            img: [
              'img_sj','img_wsj','img_ycs'
            ]
          }
          this.salesVolume = this.format(res[1].data.saleNumTotal)
          this.render_line(res[1].data);


          let product = ['引流款(A)','主推款(B)','次推款(C)','常规款(D)','形象款']
          let mode = ['大型号','小型号']
          let unsalable = '滞销款(E)'
          res[2].data.forEach(v=>{
            product.forEach(k=>{
              if(v.groupRule == k) {
                this.ProductTypeList.push(v)
              }
            })
            mode.forEach(k=>{
              if(v.groupRule == k) {
                this.modelTypeList.push(v)
              }
            })
            if(v.groupRule == unsalable) {
              this.unsalable = v
            } 
          })

          this.categorySaleTopList = res[3].data
          this.render_pie1(res[4].data[0], this.windowWith);
          if(this.columnJurisdiction) this.render_pie2(res[4].data[0], this.windowWith);
          this.render_bar(res[5].data);
          this.tableData = res[6].data.dynamicData.records
          this.columnData = res[6].data.titleList.map(v => {
            return {
              label: v.titleName,
              prop: v.propertyName,
              width: v.displayWidth,
              sortable: false,
              span: false,
              fixed: false,
            }
          })
        })
        .finally((_) => {
          loading.close();
        });
      // this.loading1 = true;
      // this.$q.goodsAnalysis
      //   .soldProducts({
      //     data: {
      //       type: "2",
      //       // ...this.time,
      //     },
      //   })
      //   .then((res) => {
      //     this.$nextTick((_) => {
      //       this.render_line(res.data);
      //     });
      //   })
      //   .finally((_) => {
      //     this.loading1 = false;
      //   });
    },
    // distributed() {
    //   this.$q.productLifeCycle
    //     .distributed({}).then((res) => {
    //       let product = ['引流款','主推款','次推款','常规款','形象款']
    //       let mode = ['大型号','小型号']
    //       let unsalable = '滞销款'
    //       res.data.forEach(v=>{
    //         product.forEach(k=>{
    //           if(v.groupRule == k) {
    //             this.ProductTypeList.push(v)
    //           }
    //         })
    //         mode.forEach(k=>{
    //           if(v.groupRule == k) {
    //             this.modelTypeList.push(v)
    //           }
    //         })
    //         if(v.groupRule == unsalable) {
    //           this.unsalable = v
    //         } 
    //       })
    //     })
    // },
    // categorySaleTop() {
    //   this.$q.productLifeCycle
    //     .categorySaleTop({})
    //     .then((res) => {
    //       this.categorySaleTopList = res.data
    //     })
    // },
    // saleMsgProportion() {
    //   this.$q.productLifeCycle
    //     .saleMsgProportion({})
    //     .then((res) => {
    //       this.render_pie1(res.data[0], this.windowWith);
    //       this.render_pie2(res.data[0], this.windowWith);
    //     })
    // },
    // productPrice() {
    //   this.$q.goodsAnalysis
    //     .productPrice({
    //       data: {
    //         type: "1",
    //         priceType: "1",
    //       },
    //     })
    //     .then((res) => {
    //       this.render_bar(res.data);
    //     })
    //     .finally((_) => {
    //       this.loading3 = false;
    //     });
    // },
    // 分页器 pagesize
    categoryTop(categoryName) {
      if(this.menus[1].children[1].children.map(v=>v.name).includes("产品概览")) {
        this.$router.push({
          path: '/goods-overview',
          query: {
            categoryName: categoryName
          }
        })
      }
    },
    productLink() {
      if(this.menus[2].children[0].children.map(v=>v.name).includes("产品搜索")) {
        this.$router.push({
          path: '/product/list'
        })
      }
    },
    newProduct(index) {
      if(this.menus[1].children[0].children.map(v=>v.name).includes("新品总览")) {
        let data = index == 0 ? 1 : index == 1 ? 0 : index
        this.$router.push({
          path: '/newProduct/newproduct-process',
          query: {
            spuOnShelfFlag: data,
            startTime: moment(new Date())
              .subtract(3, "months")
              .format("YYYY-MM-DD"),
            endTime: moment(new Date()).subtract("months").format("YYYY-MM-DD"),
          }
        })
      }  
    },
    productDetailsLink(data) {
      if(this.menus[1].children[3].children.map(v=>v.name).includes("产品滞销情况")) {
        this.$router.push({
          name: "ProductDetails",
          params: {
            saleLocation: data,
          }
        })
      }
    },
    largeModelLink(data) {
      if(data == '大型号') {
        if(this.menus[1].children[3].children.map(v=>v.name).includes("大型号品类分布")) {
          this.$router.push({
          name: "lifeCycleManagement",
          })
        }
      }else {
        if(this.menus[1].children[3].children.map(v=>v.name).includes("产品滞销情况")) {
          this.$router.push({
          name: "productUnsalable",
          })
        }
      }
      
    },
    pieClick() {
      if(this.menus[1].children[3].children.map(v=>v.name).includes("年度产品表现")) {
        this.openSubPage({
          path: '/proBehaviorYear',
          query: {
            startTime: moment()
              .startOf("year")
              .format("YYYY-MM-DD"),
            endTime: moment().format("YYYY-MM-DD"),
            activeName: 'DataSynchronizationRatio'
          }
        })
      } 
    },
    format (num) { //千分位转换
      var reg=/\d{1,3}(?=(\d{3})+$)/g;   
      return (num + '').replace(reg, '$&,');  
    },
    addDesc() {
      this.addDescVisible = true;
    },
    addCategory() {
      this.addCategoryVisible = true;
    },
  },
};
</script>
<style lang="stylus" scoped>
.container {
  margin: 5px;
  width: auto;
  height: calc(100% - 10px);
  box-sizing: border-box;
  background: #0B352B;
  border-radius: 5px;
  position: relative;

  &::before {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    content: '';
    background: url('../../../assets/images/lifeCycle_img/bg@1x.png') no-repeat center 0px;
    background-position: center 0px;
    background-size: cover;
    // z-index: -1;
  }
}

>>> .el-container {
  height: 100%;
}

>>> .el-main {
  padding: 5px 8px;
  // background #ffffff
  border-radius: 5px;
}

.header {
  height: 80%;
  // margin: 5px 5px 8px 5px;
  display: flex;
  flex-wrap: nowrap;
}

.footer {
  position: relative
  height: calc(20% - 25px);
  padding: 10px
  margin-top: 5px;
  z-index: 1
    .Bj-color {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
      background: linear-gradient(180deg, #346963 0%, #04423B 100%);
      border-radius: 2px;
      opacity: 0.8;
    }
}
.cavans {
  width: 100%;
  height: 100%;
  z-index: 999;
}

.left {
  width: 34%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}

.right {
  width: calc(66% - 10px);
  height: calc(100% - 10px);
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  padding: 10px 0 0px 10px;
  position: relative;
  z-index: 5;
}

.left-top {
  height: calc(40% - 1.04vw);
  width: 100%;
  padding: 0.52vw 0.52vw 0px 0.52vw;
  position: relative;
  z-index: 5 !important;
}

.Bj-color {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(180deg, #0B352B 0%, #0B352B 7%, #346862 100%);
  border-radius: 2px;
  opacity: 0.3;
  z-index: -1;
}

.left-bottom {
  height: calc(60% - 0.52vw);
  width: 100%;
  position: relative;
  margin-top: 0.52vw;
  padding: 0.52vw 0.52vw 0px 0.52vw;
  z-index: 5;
}

.right-top {
  // flex: 1;
  display: flex;
  height: calc(50% - 2.08vw);
  flex-wrap: nowrap;
  padding-bottom: 10px;
  // background: #cacaca
}

.right-bottom {
  // flex: 1
  display: flex;
  height: calc(50% - 20px);
  flex-wrap: nowrap;
  padding-top: 1.04vw;
  // background: #FFF
}

.title {
  font-family: SourceHanSansCN;
  color: #FFF;
  font-size: 0.95vw;
}

.title-Company {
  font-family: PingFangSC;
  color: #FFF;
  font-size: 0.7vw;
  display: inline-block;
  margin-left: 10px;
  opacity: 0.6;
}

.cavans-title {
  font-family: SourceHanSansCN;
  color: #FFF;
  font-size: 0.95vw;
  position: absolute;
  left: 10px;
  top: 0.65vw;
}

.spu-box {
  display: flex;
  flex-wrap: nowrap;
  height: calc(75% - 0.52vw);
  padding: 0.52vw 0 0 0;

  div {
    flex: 1;
    text-align: center;
    // padding-bottom: 5px;
  }

  .spu-num {
    font-family: YinHei;
    color: #2EF6D9;
    font-size: 1.8vw;
    padding-bottom: 1vw
    cursor: pointer
  }

  .spu-type {
    font-family: PingFangSC;
    color: #FFFFFF;
    font-size: 0.7vw;
    opacity: 0.8;
  }
}

.product {
  height: calc(46% - 10px);
  padding-bottom: 10px;
  border: 1px solid rgba(102, 255, 255, 0.25);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    height: calc(100% + 4px);
    width: calc(100% + 4px);
    background: linear-gradient(to top, #66FFFF, #66FFFF) left top no-repeat, linear-gradient(to right, #66FFFF, #66FFFF) left top no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) right top no-repeat, linear-gradient(to bottom, #66FFFF, #66FFFF) right top no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) left bottom no-repeat, linear-gradient(to bottom, #66FFFF, #66FFFF) left bottom no-repeat, linear-gradient(to top, #66FFFF, #66FFFF) right bottom no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) right bottom no-repeat;
    /* 右下 */
    opacity: 0.5;
    background-size: 2px 8px, 8px 2px, 2px 8px, 8px 2px;
    z-index: -1
  }
}

.largeModel {
  height: calc(44% - 10px);
  padding-top: 10px;
  display: flex;
  flex-wrap: nowrap;
}

.product-tilteBox {
  position: relative;
  height: calc(15%);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.52vw;

  ::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(90deg, #0AAD92 0%, rgba(10, 219, 139, 0.7) 100%);
    opacity: 0.8;
    z-index: -5;
  }

  .product-titleText {
    font-family: PingFangBold;
    color: #FFF;
    font-size: 0.8vw;
  }

  .product-Company {
    font-family: PingFangSC;
    color: #FFF;
    font-size: 0.7vw;
    display: inline-block;
    margin-left: 10px;
  }

  .product-num {
    font-family: YinHei;
    color: #11E7A7;
    font-size: 0.95vw;
    display: inline-block;
    margin-left: 10px;
    cursor: pointer
  }
}



.product-type {
  height: calc(85% - 1.04vw);
  display: flex;
  flex-wrap: nowrap;
  padding: 0.52vw 0.52vw 0.52vw 0;
}

.product-border-box {
  width: 100%;
  height: calc(90% - 15px);
  flex: 1;
  display: flex;
  justify-content: space-evenly; /* 水平均匀分布 */
  align-items: center; /* 垂直居中 */
  flex-direction: column;
  text-align: center;
  margin-left: 0.5vw;
  padding: 10px 0;
  border: 1px solid rgba(102, 255, 255, 0.25);
  background: linear-gradient(180deg, rgba(11, 183, 142, 0.4) 0%, rgba(11, 183, 142, 0) 100%);
  position: relative;
  cursor: pointer

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    height: calc(100% + 4px);
    width: calc(100% + 4px);
    background: linear-gradient(to top, #66FFFF, #66FFFF) left top no-repeat, linear-gradient(to right, #66FFFF, #66FFFF) left top no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) right top no-repeat, linear-gradient(to bottom, #66FFFF, #66FFFF) right top no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) left bottom no-repeat, linear-gradient(to bottom, #66FFFF, #66FFFF) left bottom no-repeat, linear-gradient(to top, #66FFFF, #66FFFF) right bottom no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) right bottom no-repeat;
    /* 右下 */
    opacity: 0.5;
    background-size: 2px 8px, 8px 2px, 2px 8px, 8px 2px;
  }

  .product-type-header {
    font-family: YinHei;
    color: #2EF6D9;
    font-size: 1.1vw;
    padding-bottom: 10px;
  }

  .product-type-content {
    font-family: PingFangSC;
    color: #FFFFFF;
    font-size: 0.8vw;
    opacity: 0.8;
    padding-bottom: 10px;
  }
}

.rise {
  font-family: PingFangSC;
  color: #2EF6D9;
  font-size: 0.8vw;
  -webkit-transform: scale(0.66);
}

.product-border-box div {
  text-align: center;
  flex: 1;
  width: 100%;
}

.uptext {
  width: 100%;

  &::after {
    display: inline-block;
    width: 12px;
    height: 12px;
    transform: scale(200%);
    margin-left: 5px;
    content: '';
    background: url('../../../assets/images/lifeCycle_img/icon_up@2x.png') no-repeat center 0px;
    background-position: center 0px;
    background-size: cover;
  }
}
.downtext {
  width: 100%;

  &::after {
    display: inline-block;
    width: 12px;
    height: 12px;
    transform: scale(200%);
    margin-left: 5px;
    content: '';
    background: url('../../../assets/images/lifeCycle_img/icon_down@2x.png') no-repeat center 0px;
    background-position: center 0px;
    background-size: cover;
  }
}

.largeModel-boderBox {
  width: 100%;
  height: calc(100% - 10px);
  flex: 1;
  justify-content: center;
  margin-right: 0.5vw;
  border: 1px solid rgba(102, 255, 255, 0.25);
  background: linear-gradient(180deg, rgba(11, 183, 142, 0.4) 0%, rgba(11, 183, 142, 0) 100%);
  position: relative;
  cursor: pointer

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    height: calc(100% + 4px);
    width: calc(100% + 4px);
    background: linear-gradient(to top, #66FFFF, #66FFFF) left top no-repeat, linear-gradient(to right, #66FFFF, #66FFFF) left top no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) right top no-repeat, linear-gradient(to bottom, #66FFFF, #66FFFF) right top no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) left bottom no-repeat, linear-gradient(to bottom, #66FFFF, #66FFFF) left bottom no-repeat, linear-gradient(to top, #66FFFF, #66FFFF) right bottom no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) right bottom no-repeat;
    /* 右下 */
    opacity: 0.5;
    background-size: 2px 8px, 8px 2px, 2px 8px, 8px 2px;
  }
}

.largeModel-title {
  position: relative;
  padding: 0.52vw;
  line-height: 100%;

  ::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(90deg, #0AAD92 0%, rgba(10, 219, 139, 0.7) 100%);
    opacity: 0.8;
    z-index: -1;
  }
}

.largeModel-dow-title {
  position: relative;
  padding: 0.52vw;
  line-height: 100%;

  ::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(45deg, #DEA60F 0%, #FFE457 100%);
    opacity: 0.8;
    z-index: -1;
  }
}

.largeModel-titleText {
  font-family: PingFangBold;
  color: #FFF;
  font-size: 0.8vw;
}

.largeModel-Company {
  font-family: PingFangSC;
  color: #FFF;
  font-size: 0.7vw;
  display: inline-block;
  margin-left: 5px;
}

.largeModel-content {
  height: 80%;
  display: flex;
  justify-content: space-evenly; /* 水平均匀分布 */
  align-items: center; /* 垂直居中 */
  flex-direction: column;
  text-align: center;

  div:nth-child(1) {
    width: 80%;
    // padding-bottom: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    border-bottom: 1px dashed #2EF6D9;
    font-family: YinHei;
    color: #2EF6D9;
    font-size: 1.1vw;
    // padding-top: 10px;
  }

  div:nth-child(2) {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -10px;
    // padding-top: 5px;
  }
}

.largeModel-dow {
  width: 100%;
  height: calc(100% - 10px);
  flex: 1;
  justify-content: center;
  border: 1px solid rgba(236, 230, 184, 0.25);
  background: linear-gradient(180deg, rgba(207, 193, 78, 0.4) 0%, rgba(208, 197, 81, 0) 100%);
  position: relative;
  cursor: pointer

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    height: calc(100% + 4px);
    width: calc(100% + 4px);
    background: linear-gradient(to top, #CFC14E, #CFC14E) left top no-repeat, linear-gradient(to right, #CFC14E, #CFC14E) left top no-repeat, linear-gradient(to left, #CFC14E, #CFC14E) right top no-repeat, linear-gradient(to bottom, #CFC14E, #CFC14E) right top no-repeat, linear-gradient(to left, #CFC14E, #CFC14E) left bottom no-repeat, linear-gradient(to bottom, #CFC14E, #CFC14E) left bottom no-repeat, linear-gradient(to top, #CFC14E, #CFC14E) right bottom no-repeat, linear-gradient(to left, #CFC14E, #CFC14E) right bottom no-repeat;
    /* 右下 */
    opacity: 0.5;
    background-size: 2px 8px, 8px 2px, 2px 8px, 8px 2px;
    z-index: -1
  }
}

.largeModel-dow-content {
  height: 80%;
  display: flex;
  justify-content: space-evenly; /* 水平均匀分布 */
  align-items: center; /* 垂直居中 */
  flex-direction: column;
  text-align: center;

  div:nth-child(1) {
    width: 80%;
    // padding-bottom: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    border-bottom: 1px dashed #F8D849;
    font-family: YinHei;
    color: #F8D849;
    font-size: 1.1vw;
    // padding-top: 5px;
  }

  div:nth-child(2) {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -10px;
    // padding-top: 5px;
    color: #F8D849;
  }
}

.salesVolume-box {
  position: absolute;
  right: 40px;
  top: 0.65vw;

  .salesVolume-text {
    font-family: PingFangSC;
    color: #fff;
    font-size: 0.8vw;
    opacity: 0.6;
  }
}

.salesVolume-num {
    font-family: PingFangSC;
    color: #F9DA4F;
    font-size:0.8vw;
    display: inline-block
    margin-left:10px
  }

.right-borderBox {
  width: calc(100% -2.08vw);
  height: calc(100% + 0.52vw);
  flex: 1;
  justify-content: center;
  margin-right: 0.5vw;
  padding: 0.52vw 1.04vw 1.04px 0.52vw;
  border: 1px solid rgba(102, 255, 255, 0.25);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    height: calc(100% + 4px);
    width: calc(100% + 4px);
    background: linear-gradient(to top, #66FFFF, #66FFFF) left top no-repeat, linear-gradient(to right, #66FFFF, #66FFFF) left top no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) right top no-repeat, linear-gradient(to bottom, #66FFFF, #66FFFF) right top no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) left bottom no-repeat, linear-gradient(to bottom, #66FFFF, #66FFFF) left bottom no-repeat, linear-gradient(to top, #66FFFF, #66FFFF) right bottom no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) right bottom no-repeat;
    /* 右下 */
    opacity: 0.5;
    background-size: 2px 8px, 8px 2px, 2px 8px, 8px 2px;
    z-index: -1
  }
}
 >>> .el-table, .el-table tr, .el-table td, {
    background-color: transparent!important;
    border: 1px solid #34786C;
  }
 
 >>> .el-table, .el-table__expanded-cell {
        background-color: transparent!important; 
    }
    
  >>> .el-table tr {
        color: #fff;
        font-family: PingFangSC !important;
        font-size: 0.65vw
        background-color: transparent!important;
    }
  >>> .el-table th {
        border-top: 0 !important
        background-color: transparent!important;
    }

 >>> .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(0, 0, 0, 0) !important;
  }
 >>> .el-table--border::after, .el-table::before {
    width: 0;
    height: 0
 }
 >>> .el-table th>.cell {
    background: linear-gradient(180deg, #137666 0%, #178A66 100%);
    font-family: PingFangBold !important;
    font-size: 0.75vw
    color: #fff;
  }
//  >>> .el-table th.el-table__cell>.cell {
//     background: linear-gradient(180deg, #137666 0%, #178A66 100%);
//     font-family: PingFangBold !important;
//     font-size: 0.75vw
//     color: #fff;
//   }
.category-Top {
  width: 100%;
  height: calc(85% - 10px);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  .category {
    width: 100%;
    flex: 1;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    position: relative;
    background: rgba(11, 183, 142, 0.1);
    border-radius: 1px;
    margin-bottom: 10px;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer

    div {
      width: 15%;
      height: 100%;
      color: #FFFFFF;
      font-size: 0.8vw;
      font-weight: 500;
      font-family: PingFangBold;
      display: flex;
      justify-content: center;
      align-items: center;

      &::before {
        content: '';
        position: absolute;
        height: 100%;
        width: 15%;
        top: 0px;
        left: 0px;
        background: linear-gradient(180deg, #0AAD92 0%, #0ADB8B 100%);
        opacity: 0.6;
        z-index: -1;
      }
    }

    .categoryName {
      font-family: PingFangSC;
      color: #FFF;
      font-size: 0.8vw;
      display: inline-block;
      margin-left: 10%;
    }
  }
}
 .exporttable >>> ::-webkit-scrollbar-track {
    background: none
}

 .exporttable >>> ::-webkit-scrollbar-thumb {
    background: linear-gradient(90deg, #137666 0%, #178a66 20%)
}
</style>
<style scoped>
@media screen and (min-width: 1920px) {
  .spu-img {
    width: 116px;
    height: 100px;
  }
  .pieColor {
    background: url('../../../assets/images/lifeCycle_img/circle@2x.png') no-repeat center 0px;
    background-size: 68%;
    background-repeat : no-repeat ;
    background-position: center center;
  }
   .spu-box {
    display: flex;
    flex-wrap: nowrap;
    height: calc(75% - 0.52vw);
    padding: 1.04vw 0 0 0;
  }
  .spu-box div {
      flex: 1;
      text-align: center;
      /* padding-bottom: 10px; */
    }
  .spu-num {
    font-family: YinHei;
    color: #2EF6D9;
    font-size: 1.8vw;
    padding-bottom: .52vw;
    cursor: pointer
  }
  .spu-type {
    font-family: PingFangSC;
    color: #FFFFFF;
    padding-bottom: .52vw;
    font-size: 0.7vw;
    opacity: 0.8;
  }
}
@media screen and (max-width: 1919px) {
  .header {
  height: calc(80% - 10px);
  display: flex;
  flex-wrap: nowrap;
  }
  .footer {
  height: calc(20% - 15px);
}
  .spu-img {
    width: 90px;
    height: 78px;
  }
  .pieColor {
    background: url('../../../assets/images/lifeCycle_img/circle.png') no-repeat center 0px;
    background-size: 58%;
    background-repeat : no-repeat ;
    background-position: center center;
  }

  ::v-deep .el-table th.el-table__cell>.cell {
    background: linear-gradient(180deg, #137666 0%, #178A66 100%);
    font-family: PingFangBold !important;
    font-size: 0.75vw;
    color: #fff;
    height: 20px;
    line-height: 20px;
  }
 ::v-deep .el-table .cell {
    height: 20px;
 }
 .product-type-header {
    font-family: YinHei;
    color: #2EF6D9;
    font-size: 1.1vw;
    padding-bottom: 5px !important;
  }
  .product-type-content {
    font-family: PingFangSC;
    color: #FFFFFF;
    font-size: 0.8vw;
    opacity: 0.8;
    padding-bottom: 5px !important;
  }
  .spu-num {
    font-family: YinHei;
    color: #2EF6D9;
    font-size: 1.8vw;
    padding-bottom: 0.52vw !important;
    cursor: pointer
  }

  .right {
  width: calc(66% - 10px);
  height: calc(100% - (10px - 0.52vw));
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  padding: 0px 0 0px 10px;
  position: relative;
  z-index: 5;
  }
.left-top {
  height: calc(40% - (1.56vw));
  width: 100%;
  padding: 0.52vw 0.52vw 0px 0.52vw;
  position: relative;
  z-index: 5 !important;
}

.left-bottom {
  height: calc(60%);
  width: 100%;
  position: relative;
  padding: 0 0.52vw 0px 0.52vw;
  z-index: 5;
}
}
</style>